import { render, staticRenderFns } from "./FactoryCommercialSignage.vue?vue&type=template&id=2a0bc028&scoped=true&"
import script from "./FactoryCommercialSignage.vue?vue&type=script&lang=ts&"
export * from "./FactoryCommercialSignage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0bc028",
  null
  
)

export default component.exports